import { authService } from "@/lib/api/auth";
import { useAuth } from "@/lib/auth";
import { useMutation } from "@tanstack/react-query";
import { useToast } from "./use-toast";

export const useLogin = () => {
  const { toast } = useToast();
  const { refreshUser } = useAuth();

  return useMutation({
    mutationFn: async (credentials: { email: string; password: string }) => {
      return authService.login(credentials.email, credentials.password);
    },
    onSuccess: async (response) => {
      toast({
        title: "Welcome back!",
        description: `Signed in as ${
          response.user.name || response.user.email
        }`,
      });
      await refreshUser();
    },
    onError: (error) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "An unexpected error occurred. Please try again.";

      toast({
        title: "Login failed",
        description: errorMessage,
        variant: "destructive",
      });
    },
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      authService.logout();
    },
  });
};
